import { CapoPlugin } from "/home/runner/work/wision/wision/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];